export default "__VITE_ASSET__2Q2wT_QQ__"